import React from 'react';

const JobCard = ({ job, isSelected, onClick }) => {
    return (
        <div
            className={`w-full border-b cursor-pointer transition-all py-3 px-4 ${
                isSelected ? 'bg-blue-50' : 'hover:bg-gray-50'
            } relative`}
            onClick={onClick}
        >
            {/* Match Score Badge */}
            <div className="absolute top-4 right-4">
                <div className="relative group">
                    <div className="bg-green-100 text-green-800 font-medium text-xs px-3 py-1 rounded-md shadow-sm hover:bg-green-200 transition">
                        {job.matchScore}% <br/> Match
                    </div>
                    {job.matchReason && (
                        <div className="absolute hidden group-hover:block top-full right-0 mt-1 bg-black text-white text-xs rounded py-2 px-3 min-w-[250px] max-w-[350px] z-10 whitespace-normal leading-relaxed">
                            {job.matchReason}
                        </div>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-3">
                {/* Company Logo */}
                <img
                    src={job.logo}
                    alt={job.company}
                    className="w-12 h-12 rounded object-cover flex-shrink-0"
                />

                {/* Content */}
                <div className="flex-1 min-w-0 text-left">
                    {/* Job Title - with limited width to not cross the red arrow */}
                    <h3 className="text-[15px] font-semibold text-gray-900 truncate max-w-[calc(100%-90px)]">
                        {job.title}
                    </h3>

                    {/* Company */}
                    <p className="text-[14px] text-gray-600 line-clamp-1">{job.company}</p>

                    {/* Location and Time */}
                    <div className="flex items-center justify-between mt-0.5">
                        <p className="text-[13px] text-gray-500 truncate max-w-[170px]">
                            {job.location.split(',')[0]}
                        </p>
                        <span className="text-[12px] text-gray-500 whitespace-nowrap flex-shrink-0">
                            {job.timeAgo}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobCard;